/* Shelving Racking Co collection page (8-10-2026). Everything here is derived
   from the collection's own products, so each collection gets only the blocks
   its data supports. */
(function () {
  var root = document.querySelector('[data-src]');
  if (!root || root.__src) return;
  root.__src = true;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var jsonEl = $('[data-src-json]');
  var RAW = [];
  try { RAW = JSON.parse(jsonEl.textContent); } catch (e) { return; }
  var TITLE = root.getAttribute('data-title') || '';
  var TITLE_LC = TITLE.toLowerCase();

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) {
    var amt = (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (window.SRC_MONEY || '£{{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amt).replace(/<[^>]+>/g, '');
  }
  function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function uniq(a) { return a.filter(function (x, i) { return x != null && a.indexOf(x) === i; }); }
  function nums(a) { return uniq(a).sort(function (x, y) { return x - y; }); }
  function range(a, unit) {
    a = nums(a); if (!a.length) return '';
    return a.length === 1 ? a[0] + (unit || '') : a[0] + '–' + a[a.length - 1] + (unit || '');
  }
  function list(a, sep, unit) { a = nums(a); return a.join(sep) + (unit || ''); }
  function num(s) { var m = /(\d+(?:\.\d+)?)/.exec(String(s || '')); return m ? parseFloat(m[1]) : null; }

  /* ---------- normalise products ---------- */
  var COLOURS = /^(blue|grey|gray|orange|black|red|green|yellow|white|silver|chrome|galvanised|galvanized|blue & orange|blue and orange|light grey|dark grey)$/i;
  function classify(t) {
    if (/extension bay/i.test(t)) return 'ext';
    if (/trolley|dolly|dollies|mobile|castor|sack truck|platform truck/i.test(t)) return 'mobile';
    if (/connector|\bshelf\b|additional|extra shel|spare|accessor|\bbeams?\b|bracket|\bclips?\b|decking|\bkit\b/i.test(t)) return 'part';
    if (/(shelving|racking)/i.test(t) && /(box|boxes|bins?\b|workbench|bundle)/i.test(t)) return 'bundle';
    if (/high-performance/i.test(t)) return 'hp';
    if (/shelving|racking|\bunit\b|\bbay\b/i.test(t)) return 'unit';
    return 'other';
  }
  var TYPE = {
    unit: { label: 'Shelving units', badge: 'Unit', cls: 'n' },
    hp: { label: 'High-performance', badge: 'High-performance', cls: 'hp' },
    ext: { label: 'Extension bays', badge: 'Extension bay', cls: 'o' },
    part: { label: 'Shelves & parts', badge: 'Spare part', cls: 'w' },
    mobile: { label: 'Trolleys & mobile', badge: 'Mobile', cls: 'w' },
    bundle: { label: 'Bundles', badge: 'Bundle', cls: 'w' },
    other: { label: 'Other', badge: '', cls: '' }
  };
  function optIndex(names, re) { for (var i = 0; i < names.length; i++) if (re.test(names[i])) return i; return -1; }

  var P = RAW.map(function (r, idx) {
    var t = r.t, names = r.o || [];
    var p = { idx: idx, id: r.i, t: t, u: r.u, a: r.a, type: classify(t), names: names };
    var mh = /(\d{3,4})\s?mm\s*(?:high|height|tall|h\b)/i.exec(t);
    p.h = mh ? parseInt(mh[1], 10) : null;
    var mm = /^\s*(\d+)\s*x\s/i.exec(t); p.multi = mm ? parseInt(mm[1], 10) : 0;
    var ml = /(\d{2,4})(?:\s*\/\s*(\d{2,4}))?\s?kg/i.exec(t); p.tload = ml ? uniq([parseInt(ml[1], 10), ml[2] ? parseInt(ml[2], 10) : null]) : [];
    var segs = t.split(/\s+-\s+/); var last = segs[segs.length - 1].trim();
    p.finish = segs.length > 1 && COLOURS.test(last) ? last.replace(/\band\b/i, '&') : null;
    var iw = optIndex(names, /width/i), id = optIndex(names, /depth/i), il = optIndex(names, /levels?|tiers?/i), ild = optIndex(names, /load|udl/i), idim = optIndex(names, /dimension/i);
    p.v = (r.v || []).map(function (a) {
      var o = [a[1], a[2], a[3]];
      var v = { id: a[0], o: o, price: a[4], av: !!a[5] };
      v.w = iw > -1 ? num(o[iw]) : null;
      v.d = id > -1 ? num(o[id]) : null;
      v.lv = il > -1 ? num(o[il]) : null;
      v.load = ild > -1 ? num(o[ild]) : (p.tload.length === 1 ? p.tload[0] : null);
      v.h = p.h;
      if (idim > -1) {
        var s = String(o[idim] || '');
        var dd = /(\d{2,4})\s*d\b/i.exec(s), ww = /(\d{2,4})\s*w\b/i.exec(s), hh = /(\d{2,4})\s*h\b/i.exec(s);
        if (dd) v.d = parseInt(dd[1], 10); if (ww) v.w = parseInt(ww[1], 10); if (hh) v.h = parseInt(hh[1], 10);
      }
      return v;
    });
    if (!p.h) { var hs = uniq(p.v.map(function (v) { return v.h; })); if (hs.length) p.hs = hs; }
    else p.hs = [p.h];
    p.hs = p.hs || [];
    p.lv = (function () { var m = /(\d)\s*(?:levels?|tiers?|shelves)\b/i.exec(t); return m ? parseInt(m[1], 10) : null; })();
    p.minPrice = Math.min.apply(null, p.v.map(function (v) { return v.price; }));
    return p;
  });
  var isFrame = function (p) { return p.type === 'unit' || p.type === 'hp' || p.type === 'ext'; };
  var FRAMES = P.filter(isFrame);
  /* a shelving collection when frames (units, bays) make up a fair share of it */
  var SHELF = FRAMES.length > 0 && FRAMES.length >= 0.3 * P.length;
  var BASE = SHELF ? FRAMES : P;
  var LOADWORD = SHELF ? 'per shelf' : 'capacity';
  /* a size fact is shown only when at least half the products carry it */
  function covers(fn) { var n = BASE.filter(fn).length; return n > 0 && n >= BASE.length / 2; }

  /* ---------- hero fact chips ---------- */
  (function () {
    var ul = $('[data-src-facts]'); if (!ul) return;
    var chips = [];
    var loads = []; BASE.forEach(function (p) { p.v.forEach(function (v) { if (v.load) loads.push(v.load); }); p.tload.forEach(function (l) { loads.push(l); }); });
    loads = nums(loads);
    var hasLoad = covers(function (p) { return p.tload.length || p.v.some(function (v) { return v.load; }); });
    if (hasLoad && loads.length === 1) chips.push(loads[0] + 'kg capacity' + (SHELF ? ' units' : ''));
    else if (hasLoad && loads.length > 1) chips.push(loads.length <= 3 ? list(loads, ' / ', 'kg ' + LOADWORD) : 'Up to ' + loads[loads.length - 1] + 'kg ' + LOADWORD);
    var hs = []; BASE.forEach(function (p) { p.hs.forEach(function (h) { hs.push(h); }); }); hs = nums(hs);
    if (hs.length && covers(function (p) { return p.hs.length; })) chips.push((hs.length === 1 ? 'Height ' : 'Heights ') + (hs.length <= 4 ? hs.join(' · ') : hs[0] + '–' + hs[hs.length - 1]) + 'mm');
    var ws = [], ds = [], ls = [];
    BASE.forEach(function (p) { p.v.forEach(function (v) { if (v.w) ws.push(v.w); if (v.d) ds.push(v.d); if (v.lv) ls.push(v.lv); }); if (p.lv) ls.push(p.lv); });
    var cw = covers(function (p) { return p.v.some(function (v) { return v.w; }); }), cd = covers(function (p) { return p.v.some(function (v) { return v.d; }); }), cl = covers(function (p) { return p.lv || p.v.some(function (v) { return v.lv; }); });
    if (ws.length && cw) chips.push((nums(ws).length === 1 ? 'Width ' : 'Widths ') + range(ws, 'mm'));
    if (ds.length && cd) { var dn = nums(ds); chips.push((dn.length === 1 ? 'Depth ' : 'Depths ') + (dn.length <= 3 ? dn.join(' · ') : range(dn)) + 'mm'); }
    if (ls.length && cl) { var ln = nums(ls); chips.push(ln.length === 1 ? ln[0] + ' levels' : (ln.length <= 3 ? ln.slice(0, -1).join(', ') + ' or ' + ln[ln.length - 1] : range(ln)) + ' levels'); }
    var fin = uniq(P.map(function (p) { return p.finish; })); if (fin.length > 1 && fin.length <= 4) chips.push(fin.join(', ') + ' finishes');
    ul.insertAdjacentHTML('beforeend', chips.map(function (c) { return '<li>' + esc(c) + '</li>'; }).join(''));
  })();

  /* ---------- cards: badges + spec chips ---------- */
  var cards = $$('.src-card');
  cards.forEach(function (li) {
    var p = P[parseInt(li.getAttribute('data-pi'), 10)]; if (!p) return;
    p.el = li;
    var b = $('[data-badge]', li), T = TYPE[p.type];
    var badge = p.multi > 1 && (p.type === 'unit' || p.type === 'hp') ? p.multi + ' units' : T.badge;
    if (badge) { b.textContent = badge; b.className = 'src-badge src-badge--' + (p.multi > 1 ? 'n' : T.cls); b.hidden = false; }
    var s = [];
    if (p.hs.length) s.push(range(p.hs, 'mm high'));
    var ws = p.v.map(function (v) { return v.w; }).filter(Boolean), ds = p.v.map(function (v) { return v.d; }).filter(Boolean);
    if (ws.length && ds.length) s.push(range(ws) + ' × ' + range(ds, 'mm'));
    else if (ws.length) s.push(range(ws, 'mm wide'));
    else if (ds.length) s.push(range(ds, 'mm deep'));
    var ls = p.v.map(function (v) { return v.lv; }).filter(Boolean); if (p.lv) ls.push(p.lv);
    if (ls.length) s.push(range(ls, ' levels'));
    var lo = p.v.map(function (v) { return v.load; }).filter(Boolean).concat(p.tload);
    if (lo.length && !ls.length) s.push(list(lo, '/', 'kg'));
    if (!s.length && p.names.length && !(p.names.length === 1 && /^title$/i.test(p.names[0]))) {
      var vals = uniq(p.v.map(function (v) { return v.o[0]; }));
      s.push(vals.length === 1 ? vals[0] : vals.length + ' ' + (/size|dimension/i.test(p.names[0]) ? 'sizes' : 'options'));
    }
    $('[data-specs]', li).innerHTML = s.slice(0, 3).map(function (x) { return '<span>' + esc(x) + '</span>'; }).join('');
  });

  /* ---------- quick add (single-variant cards) ---------- */
  $$('[data-src-add]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('button', f), txt = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +f.elements.id.value, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw 0; btn.textContent = 'Added'; setTimeout(function () { btn.textContent = txt; btn.disabled = false; }, 1800); })
        .catch(function () { f.submit(); });
    });
  });

  /* ---------- views ---------- */
  var grid = $('[data-src-cards]');
  function setView(v) {
    grid.setAttribute('data-view', v);
    $$('[data-src-view]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-src-view') === v ? 'true' : 'false'); });
    try { localStorage.setItem('src_view', v); } catch (e) {}
  }
  $$('[data-src-view]').forEach(function (b) { b.addEventListener('click', function () { setView(b.getAttribute('data-src-view')); }); });
  try { var sv = localStorage.getItem('src_view'); if (sv) setView(sv); else if (window.matchMedia('(max-width: 767px)').matches) setView('s'); } catch (e) {}

  /* ---------- sort ---------- */
  var sortSel = $('[data-src-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var u = new URL(location.href); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); u.hash = 'src-grid'; location.href = u.toString();
  });

  /* ---------- filters ---------- */
  var groups = [];
  function addGroup(key, label, valueOf, order, fmtV) {
    var counts = {};
    P.forEach(function (p) { if (!p.el) return; valueOf(p).forEach(function (v) { counts[v] = (counts[v] || 0) + 1; }); });
    var vals = Object.keys(counts); if (vals.length < 2) return;
    vals.sort(order || function (a, b) { return counts[b] - counts[a]; });
    groups.push({ key: key, label: label, vals: vals, counts: counts, valueOf: valueOf, fmt: fmtV || function (v) { return v; } });
  }
  var typeOrder = ['unit', 'hp', 'ext', 'part', 'mobile', 'bundle', 'other'];
  addGroup('type', 'Product type', function (p) { return [p.type]; }, function (a, b) { return typeOrder.indexOf(a) - typeOrder.indexOf(b); }, function (v) { return TYPE[v].label; });
  addGroup('h', 'Height', function (p) { return p.hs.map(String); }, function (a, b) { return a - b; }, function (v) { return v + 'mm'; });
  addGroup('load', SHELF ? 'Load per shelf' : 'Load capacity', function (p) { var l = p.v.map(function (v) { return v.load; }).filter(Boolean).concat(p.tload); return uniq(l).map(String); }, function (a, b) { return a - b; }, function (v) { return v + 'kg'; });
  addGroup('fin', 'Finish', function (p) { return p.finish ? [p.finish] : []; });
  var sel = {};
  var side = $('[data-src-side]');
  function renderSide() {
    if (!groups.length) { side.hidden = true; root.classList.add('src--noside'); return; }
    var total = P.filter(function (p) { return p.el; }).length;
    side.innerHTML = groups.map(function (g) {
      return '<div class="src-fg"><p class="src-fg__h">' + esc(g.label) + '</p><div class="src-fg__l">' +
        '<button type="button" data-g="' + g.key + '" data-v=""' + (!sel[g.key] ? ' aria-pressed="true"' : ' aria-pressed="false"') + '>' + (g.key === 'type' ? 'All products' : 'Any ' + esc(g.label.toLowerCase())) + '<b>' + total + '</b></button>' +
        g.vals.map(function (v) { return '<button type="button" data-g="' + g.key + '" data-v="' + esc(v) + '" aria-pressed="' + (sel[g.key] === v) + '">' + esc(g.fmt(v)) + '<b>' + g.counts[v] + '</b></button>'; }).join('') +
        '</div></div>';
    }).join('') + '<p class="src-fg__q">Need a size that isn\'t listed? <a href="' + esc(root.getAttribute('data-quote')) + '">Ask for a quote</a></p>';
    side.hidden = false;
  }
  function applyFilters() {
    var shown = 0;
    P.forEach(function (p) {
      if (!p.el) return;
      var ok = groups.every(function (g) { return !sel[g.key] || g.valueOf(p).indexOf(sel[g.key]) > -1; });
      p.el.hidden = !ok; if (ok) shown++;
    });
    var total = P.filter(function (p) { return p.el; }).length;
    var sh = $('[data-src-showing]'); if (sh) sh.textContent = 'Showing ' + shown + ' of ' + total + ' products';
    $('[data-src-none]').hidden = shown > 0;
    $$('button[data-g]', side).forEach(function (b) { var g = b.getAttribute('data-g'), v = b.getAttribute('data-v'); b.setAttribute('aria-pressed', (sel[g] || '') === v ? 'true' : 'false'); });
  }
  renderSide();
  side.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-g]'); if (!b) return;
    var g = b.getAttribute('data-g'), v = b.getAttribute('data-v');
    if (v && sel[g] === v) v = '';
    if (v) sel[g] = v; else delete sel[g];
    applyFilters();
  });
  $('[data-src-clear]').addEventListener('click', function () { sel = {}; applyFilters(); });
  function filterHeight(h) {
    if (groups.some(function (g) { return g.key === 'h'; })) { sel = { h: String(h) }; applyFilters(); }
    document.getElementById('src-grid').scrollIntoView({ behavior: 'smooth' });
  }

  /* ---------- size finder ---------- */
  var UNITS = P.filter(function (p) { return (p.type === 'unit' || p.type === 'hp') && !p.multi && p.h && p.v.some(function (v) { return v.w; }); });
  var EXTS = P.filter(function (p) { return p.type === 'ext' && p.h && p.v.some(function (v) { return v.w; }); });
  var CONN = P.filter(function (p) { return /connector/i.test(p.t) && p.v.length; })[0];
  var finderOn = UNITS.length >= 1 && UNITS.reduce(function (n, p) { return n + p.v.length; }, 0) >= 4;
  var F = { h: null, w: null, d: null, lv: null, load: null, model: null, n: 1, conn: false };
  var DIMS = [['w', 'Width', '(mm, each bay)'], ['d', 'Depth', '(mm)'], ['lv', 'Levels', ''], ['load', 'Load per shelf', '(kg)']];
  function atH() { return UNITS.filter(function (p) { return p.h === F.h; }); }
  function matches(v, skip) { return DIMS.every(function (d) { var k = d[0]; return k === skip || F[k] == null || v[k] == null || v[k] === F[k]; }); }
  function pick() {
    var ps = atH(), best = null;
    ps.forEach(function (p) {
      if (F.model && p.id !== F.model) return;
      p.v.forEach(function (v) { if (matches(v) && (!best || (v.av && !best.v.av) || (v.av === best.v.av && v.price < best.v.price))) best = { p: p, v: v }; });
    });
    if (!best && F.model) { F.model = null; return pick(); }
    return best;
  }
  function extFor(sel) {
    if (!sel) return null;
    var cands = EXTS.filter(function (p) { return p.h === F.h; });
    var w1 = sel.p.t.split(/\s+/)[0].toLowerCase();
    cands.sort(function (a, b) { return (b.t.split(/\s+/)[0].toLowerCase() === w1) - (a.t.split(/\s+/)[0].toLowerCase() === w1); });
    for (var i = 0; i < cands.length; i++) {
      var v = cands[i].v.filter(function (v) { return v.w === sel.v.w && (v.d == null || v.d === sel.v.d) && (v.lv == null || v.lv === sel.v.lv); })[0];
      if (v) return { p: cands[i], v: v };
    }
    return null;
  }
  function chip(k, val, label, on, dis) { return '<button type="button" class="src-ch' + (on ? ' on' : '') + '" data-k="' + k + '" data-val="' + esc(val) + '"' + (dis ? ' disabled' : '') + ' aria-pressed="' + on + '">' + esc(label) + '</button>'; }
  function renderFinder() {
    var opts = $('[data-src-opts]'), n = 1, h = '';
    var hs = nums(UNITS.map(function (p) { return p.h; }));
    h += '<div class="src-step"><p class="src-step__h">' + (n++) + '. Height</p><div class="src-hcards">' + hs.map(function (x) {
      var mn = Math.min.apply(null, UNITS.filter(function (p) { return p.h === x; }).map(function (p) { return p.minPrice; }));
      return '<button type="button" class="src-hcard' + (F.h === x ? ' on' : '') + '" data-k="h" data-val="' + x + '" aria-pressed="' + (F.h === x) + '"><b>' + x + 'mm</b><small>units from ' + esc(money(mn)) + '</small></button>';
    }).join('') + '</div></div>';
    var ps = atH(), pair = '';
    DIMS.forEach(function (d) {
      var k = d[0], vals = [];
      ps.forEach(function (p) { p.v.forEach(function (v) { if (v[k] != null) vals.push(v[k]); }); });
      vals = nums(vals); if (vals.length < 2) return;
      var block = '<div class="src-step"><p class="src-step__h">' + (n++) + '. ' + d[1] + (d[2] ? ' <span>' + d[2] + '</span>' : '') + '</p><div class="src-chs">' + vals.map(function (x) {
        var ok = ps.some(function (p) { return p.v.some(function (v) { return v[k] === x && matches(v, k); }); });
        return chip(k, x, x, F[k] === x, !ok);
      }).join('') + '</div></div>';
      if (k === 'd' || k === 'lv') pair += block; else h += block;
      if (k === 'lv' || (k === 'd' && !ps.some(function (p) { return p.v.some(function (v) { return v.lv != null; }); }))) { h += '<div class="src-pair">' + pair + '</div>'; pair = ''; }
    });
    if (pair) h += '<div class="src-pair">' + pair + '</div>';
    var models = ps.filter(function (p) { return p.v.some(function (v) { return matches(v); }); });
    if (models.length > 1) {
      h += '<div class="src-step"><p class="src-step__h">' + (n++) + '. Range</p><div class="src-models">' + models.map(function (p) {
        var v = p.v.filter(function (v) { return matches(v); }).sort(function (a, b) { return a.price - b.price; })[0];
        var cur = pick(); var on = cur && cur.p.id === p.id;
        return '<button type="button" class="src-model' + (on ? ' on' : '') + '" data-k="model" data-val="' + p.id + '" aria-pressed="' + on + '"><span>' + esc(p.t) + '</span><b>' + esc(money(v.price)) + '</b></button>';
      }).join('') + '</div></div>';
    }
    var cur = pick(), ext = extFor(cur);
    h += '<div class="src-step"><p class="src-step__h">' + (n++) + '. Bays side by side</p><div class="src-bays"><div class="src-qty"><button type="button" data-q="-1" aria-label="One fewer bay">−</button><output>' + F.n + '</output><button type="button" data-q="1" aria-label="One more bay">+</button></div><span data-src-baytxt></span></div></div>';
    if (CONN && ext && F.n > 1) {
      var cv = CONN.v[0];
      h += '<label class="src-conn"><input type="checkbox" data-src-conn' + (F.conn ? ' checked' : '') + '><span><b>Add bay connectors</b> — ' + esc((cv.o[0] && !/default/i.test(cv.o[0]) ? cv.o[0] + ', ' : '') + money(cv.price)) + ' each</span></label>';
    }
    opts.innerHTML = h;
    renderOut(cur, ext);
  }
  function renderOut(cur, ext) {
    var sum = $('[data-src-sum]'), svg = $('[data-src-svg]');
    var txt = $('[data-src-baytxt]');
    $$('[data-src-extkey]').forEach(function (e) { e.hidden = !ext; });
    if (!cur) { sum.innerHTML = '<p class="src-sum__none">That combination is not listed. <a href="' + esc(root.getAttribute('data-quote')) + '">Ask us for a quote</a>.</p>'; svg.innerHTML = ''; if (txt) txt.textContent = ''; return; }
    var w = cur.v.w, d = cur.v.d, n = F.n, L = w * n, useExt = !!ext && n > 1;
    var lvs = cur.v.lv || cur.p.lv || 4;
    if (txt) txt.textContent = (useExt ? '1 unit + ' + (n - 1) + ' extension bay' + (n > 2 ? 's' : '') : n + ' unit' + (n > 1 ? 's' : '') + ' side by side') + ' · ' + fmt(L) + 'mm long';
    svg.innerHTML = drawRun(w, cur.v.h || cur.p.h, n, lvs, useExt, d);
    var lines = [], total = 0, items = [];
    var dims = [w, d, cur.p.h].filter(Boolean).join(' × ') + 'mm' + (cur.v.lv ? ' · ' + cur.v.lv + ' levels' : '') + (cur.v.load ? ' · ' + cur.v.load + 'kg' : '');
    var unitQty = useExt ? 1 : n;
    lines.push({ h: 'Unit' + (unitQty > 1 ? ' × ' + unitQty : ''), s: dims + (unitQty > 1 ? ' · ' + money(cur.v.price) + ' each' : ''), p: cur.p, price: cur.v.price * unitQty });
    items.push({ id: cur.v.id, quantity: unitQty }); total += cur.v.price * unitQty;
    if (useExt) {
      lines.push({ h: 'Extension bay × ' + (n - 1), s: money(ext.v.price) + ' each', p: ext.p, price: ext.v.price * (n - 1) });
      items.push({ id: ext.v.id, quantity: n - 1 }); total += ext.v.price * (n - 1);
      if (F.conn && CONN) { var cv = CONN.v[0]; lines.push({ h: 'Bay connectors × ' + (n - 1), s: money(cv.price) + ' each', p: CONN, price: cv.price * (n - 1) }); items.push({ id: cv.id, quantity: n - 1 }); total += cv.price * (n - 1); }
    }
    var av = cur.v.av && (!useExt || ext.v.av);
    var q = new URLSearchParams({ product: TITLE + ': ' + cur.p.t + (useExt ? ' + ' + (n - 1) + ' x ' + ext.p.t : ''), size: dims + (n > 1 ? ' · run ' + fmt(L) + 'mm' : ''), qty: String(n) });
    sum.innerHTML = lines.map(function (l) {
      return '<div class="src-line"><div><p><b>' + esc(l.h) + '</b> · ' + esc(l.s) + '</p><a href="' + esc(l.p.u) + '">' + esc(l.p.t) + '</a></div><b>' + esc(money(l.price)) + '</b></div>';
    }).join('') +
      '<div class="src-total"><span><b>Run total</b> inc. VAT</span><strong>' + esc(money(total)) + '</strong></div>' +
      '<div class="src-sum__btns"><button type="button" class="src-btn src-btn--go" data-src-addrun' + (av ? '' : ' disabled') + '>' + (av ? 'Add ' + (n > 1 ? n + ' bays' : 'to basket') + (n > 1 ? ' to basket' : '') : 'Out of stock') + '</button>' +
      '<a class="src-btn src-btn--line" href="' + esc(root.getAttribute('data-quote')) + '?' + q.toString() + '">Quote for this ' + (n > 1 ? 'run' : 'size') + '</a></div><p class="src-sum__msg" data-src-msg role="status"></p>';
    var addBtn = $('[data-src-addrun]', sum);
    addBtn.addEventListener('click', function () {
      addBtn.disabled = true; var msg = $('[data-src-msg]', sum); msg.textContent = 'Adding to basket…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) { addBtn.disabled = false; msg.textContent = res.ok ? 'Added to your basket.' : (res.j.description || 'Could not add to basket.'); })
        .catch(function () { addBtn.disabled = false; msg.textContent = 'Could not reach the basket. Please try again.'; });
    });
  }
  function drawRun(w, h, n, lv, useExt, d) {
    var L = w * n, VW = 640, VH = 330, padL = 70, padR = 20, top = 46, base = 270;
    var s = Math.min((VW - padL - padR) / L, (base - top) / h);
    var x0 = padL + ((VW - padL - padR) - L * s) / 2, y0 = base - h * s;
    var g = '', grid = 500 * s, i, k;
    for (i = 0; i * grid < VW; i++) g += '<path d="M' + (i * grid).toFixed(1) + ' 0V' + VH + '" class="gl"/>';
    for (i = 0; i * grid < VH; i++) g += '<path d="M0 ' + (base - i * grid).toFixed(1) + 'H' + VW + '" class="gl"/>';
    var out = '<svg viewBox="0 0 ' + VW + ' ' + VH + '" role="img" aria-label="' + n + ' bay' + (n > 1 ? 's' : '') + ', ' + fmt(L) + 'mm long, ' + h + 'mm high"><g>' + g + '</g>';
    for (i = 0; i < n; i++) {
      var bx = x0 + i * w * s, ext = useExt && i > 0, col = ext ? '#FF7A1A' : '#5B6676';
      for (k = 0; k < lv; k++) { var yy = base - 6 - k * ((h * s - 12) / Math.max(1, lv - 1)); out += '<path d="M' + bx.toFixed(1) + ' ' + yy.toFixed(1) + 'h' + (w * s).toFixed(1) + '" class="sh"/>'; }
      if (!ext) out += '<path d="M' + bx.toFixed(1) + ' ' + y0.toFixed(1) + 'V' + base + '" stroke="' + col + '" class="po"/>';
      out += '<path d="M' + (bx + w * s).toFixed(1) + ' ' + y0.toFixed(1) + 'V' + base + '" stroke="' + col + '" class="po"/>';
      if (n <= 8) out += '<text x="' + (bx + w * s / 2).toFixed(1) + '" y="' + (y0 - 10).toFixed(1) + '" class="lb' + (ext ? ' o' : '') + '">' + (ext ? 'EXT' : 'UNIT') + '</text>';
    }
    out += '<path d="M10 ' + base + 'H' + (VW - 10) + '" class="fl"/>';
    out += '<path d="M' + (x0 - 14) + ' ' + y0.toFixed(1) + 'V' + base + '" class="dm"/><text x="' + (x0 - 20) + '" y="' + ((y0 + base) / 2 + 5).toFixed(1) + '" class="dt" text-anchor="end">' + h + 'mm</text>';
    out += '<path d="M' + x0.toFixed(1) + ' ' + (base + 18) + 'H' + (x0 + L * s).toFixed(1) + '" class="dm"/><text x="' + (x0 + L * s / 2).toFixed(1) + '" y="' + (base + 40) + '" class="dt">' + fmt(L) + 'mm long' + (d ? ' × ' + d + 'mm deep' : '') + '</text>';
    return out + '</svg>';
  }
  if (finderOn) {
    var finder = $('[data-src-finder]');
    var hsAll = nums(UNITS.map(function (p) { return p.h; }));
    F.h = hsAll[Math.floor((hsAll.length - 1) / 2)];
    (function initDims() {
      var ps = atH(), vs = []; ps.forEach(function (p) { p.v.forEach(function (v) { if (v.av) vs.push(v); }); });
      if (!vs.length) ps.forEach(function (p) { vs = vs.concat(p.v); });
      var ws = nums(vs.map(function (v) { return v.w; }));
      var tw = ws.filter(function (x) { return x >= 1100 && x <= 1300; })[0] || ws[Math.floor((ws.length - 1) / 2)];
      F.w = tw;
      var rest = vs.filter(function (v) { return v.w === tw; });
      ['d', 'lv', 'load'].forEach(function (k) { var a = nums(rest.map(function (v) { return v[k]; })); F[k] = a.length ? a[Math.floor((a.length - 1) / 2)] : null; rest = rest.filter(function (v) { return v[k] == null || v[k] === F[k]; }); });
      F.n = EXTS.length ? 3 : 1;
    })();
    $('[data-src-finderlead]').textContent = 'Every ' + TITLE_LC.replace(/s$/, '') + ' size we list, priced before you open a product.' + (EXTS.length ? ' Add bays to build a longer run.' : '');
    finder.addEventListener('click', function (e) {
      var b = e.target.closest('[data-k]');
      if (b) {
        var k = b.getAttribute('data-k'), v = b.getAttribute('data-val');
        F[k] = k === 'model' ? parseInt(v, 10) : parseFloat(v);
        if (k === 'h') { F.model = null; }
        /* keep the other choices where they still exist, otherwise move to the nearest that does */
        DIMS.forEach(function (d) {
          var kk = d[0]; if (kk === k) return;
          var vals = []; atH().forEach(function (p) { p.v.forEach(function (x) { if (x[kk] != null && matches(x, kk)) vals.push(x[kk]); }); });
          vals = nums(vals);
          if (!vals.length) { F[kk] = null; return; }
          if (F[kk] == null || vals.indexOf(F[kk]) < 0) F[kk] = vals.reduce(function (a, c) { return Math.abs(c - (F[kk] || c)) < Math.abs(a - (F[kk] || a)) ? c : a; }, vals[0]);
        });
        renderFinder(); return;
      }
      var q = e.target.closest('[data-q]');
      if (q) { F.n = Math.max(1, Math.min(10, F.n + parseInt(q.getAttribute('data-q'), 10))); renderFinder(); }
    });
    finder.addEventListener('change', function (e) { if (e.target.matches('[data-src-conn]')) { F.conn = e.target.checked; renderFinder(); } });
    renderFinder();
    finder.hidden = false;
    $('[data-src-findbtn]').hidden = false;
    var br = $('[data-src-buildrun]'); if (br && EXTS.length) br.hidden = false;
  }

  /* ---------- heights to scale ---------- */
  (function () {
    var src = UNITS.length ? UNITS : FRAMES.filter(function (p) { return p.type !== 'ext'; });
    var hs = nums(src.map(function (p) { return p.h; }));
    if (hs.length < 2 || hs.length > 5) return;
    var sec = $('[data-src-heights]');
    $('[data-src-heightsh]').textContent = ['', '', 'Two', 'Three', 'Four', 'Five'][hs.length] + ' heights, side by side';
    var maxH = Math.max(hs[hs.length - 1], 1750), VH = 340, base = 330, s = (base - 10) / maxH;
    var cols = hs.length + 1, VW = 1000, cw = VW / cols, bw = Math.min(150, cw * 0.55);
    var svg = '<svg viewBox="0 0 ' + VW + ' ' + (VH + 4) + '" role="img" aria-label="Heights ' + hs.join(', ') + 'mm next to a 1.75m person">';
    hs.forEach(function (h, i) {
      var cx = cw * i + cw / 2, x = cx - bw / 2, y = base - h * s;
      var lv = 0; src.forEach(function (p) { if (p.h === h) p.v.forEach(function (v) { if (v.lv) lv = Math.max(lv, v.lv); }); });
      lv = lv || 5;
      svg += '<path d="M' + x + ' ' + y + 'V' + base + 'M' + (x + bw) + ' ' + y + 'V' + base + '" class="po"/>';
      for (var k = 0; k < lv; k++) { var yy = base - 4 - k * ((h * s - 14) / (lv - 1)); svg += '<path d="M' + x + ' ' + yy.toFixed(1) + 'h' + bw + '" class="sh"/>'; }
    });
    var px = cw * hs.length + cw / 2, ph = 1750 * s, py = base - ph, u = ph / 8;
    svg += '<g class="ps"><circle cx="' + px + '" cy="' + (py + u * 0.55) + '" r="' + (u * 0.5) + '"/><rect x="' + (px - u * 0.55) + '" y="' + (py + u * 1.15) + '" width="' + (u * 1.1) + '" height="' + (u * 3) + '" rx="' + (u * 0.3) + '"/><rect x="' + (px - u * 0.85) + '" y="' + (py + u * 1.2) + '" width="' + (u * 0.28) + '" height="' + (u * 2.6) + '" rx="' + (u * 0.14) + '"/><rect x="' + (px + u * 0.57) + '" y="' + (py + u * 1.2) + '" width="' + (u * 0.28) + '" height="' + (u * 2.6) + '" rx="' + (u * 0.14) + '"/><rect x="' + (px - u * 0.5) + '" y="' + (py + u * 4) + '" width="' + (u * 0.42) + '" height="' + (u * 4) + '" rx="' + (u * 0.2) + '"/><rect x="' + (px + u * 0.08) + '" y="' + (py + u * 4) + '" width="' + (u * 0.42) + '" height="' + (u * 4) + '" rx="' + (u * 0.2) + '"/></g>';
    svg += '<path d="M0 ' + base + 'H' + VW + '" class="fl"/></svg>';
    var labels = '<div class="src-hl" style="grid-template-columns:repeat(' + cols + ',1fr)">' + hs.map(function (h) {
      return '<div><b>' + h + 'mm</b>' + (groups.some(function (g) { return g.key === 'h'; }) ? '<button type="button" data-src-hshop="' + h + '">Shop ' + h + 'mm</button>' : '') + '</div>';
    }).join('') + '<div><small>1.75m person</small></div></div>';
    $('[data-src-heightsfig]').innerHTML = svg + labels;
    sec.addEventListener('click', function (e) { var b = e.target.closest('[data-src-hshop]'); if (b) filterHeight(b.getAttribute('data-src-hshop')); });
    sec.hidden = false;
  })();

  /* ---------- unit vs extension bay ---------- */
  if (EXTS.length) $('[data-src-bay]').hidden = false;

  /* ---------- about: show more ---------- */
  (function () {
    var rte = $('[data-src-rte]'), more = $('[data-src-more]');
    if (!rte || !more) return;
    if (rte.scrollHeight > 420) {
      rte.classList.add('is-clamped'); more.hidden = false;
      more.addEventListener('click', function () {
        var open = rte.classList.toggle('is-clamped') === false;
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.textContent = open ? 'Show less' : 'More about ' + TITLE_LC;
      });
    }
  })();

  /* ---------- questions the data can answer ---------- */
  (function () {
    var qs = [];
    var vs = []; BASE.forEach(function (p) { if (p.type !== 'part' && p.type !== 'mobile') p.v.forEach(function (v) { vs.push(v); }); });
    var ds = nums(vs.map(function (v) { return v.d; })), ws = nums(vs.map(function (v) { return v.w; }));
    if (SHELF && ds.length >= 2) {
      var notAll = ws.filter(function (w) { return nums(vs.filter(function (v) { return v.w === w; }).map(function (v) { return v.d; })).length < ds.length; });
      var a = ds[0] + 'mm suits corridors, cupboards and small rooms where floor space is tight; ' + ds[ds.length - 1] + 'mm takes the widest boxes and trays.';
      if (ws.length > 1) a += notAll.length === 0 ? ' Every width is made in all ' + ds.length + ' depths.' : (notAll.length <= 3 ? ' Every width except ' + notAll.join(', ') + 'mm is made in all ' + ds.length + ' depths.' : '');
      qs.push(['Which depth should I choose?', a]);
    }
    if (EXTS.length) {
      var ew = nums(EXTS.reduce(function (a, p) { return a.concat(p.v.map(function (v) { return v.w; })); }, []));
      var ex = ew.indexOf(1220) > -1 ? 1220 : ew[Math.floor((ew.length - 1) / 2)];
      qs.push(['How long will my run be?', 'Add up the bay widths. One unit plus two extension bays at ' + fmt(ex) + 'mm is ' + fmt(ex * 3) + 'mm long. The finder above draws the run to scale and prices every part.']);
    } else if (finderOn) {
      qs.push(['Can I stand units side by side?', 'Yes. Each unit is free-standing, so the length of a row is the units’ widths added together. The finder above draws it to scale.']);
    }
    var shelf = P.filter(function (p) { return p.type === 'part' && /\bshel(f|ves)\b/i.test(p.t); })[0];
    if (shelf) qs.push(['Can I add shelves later?', 'Yes. <a href="' + esc(shelf.u) + '">' + esc(shelf.t) + '</a> is sold on its own' + (function () { var sw = nums(shelf.v.map(function (v) { return v.w; })); return sw.length ? ', in widths ' + range(sw, 'mm') : ''; })() + ', from ' + esc(money(shelf.minPrice)) + '.', true]);
    var loads = []; BASE.forEach(function (p) { p.v.forEach(function (v) { if (v.load) loads.push(v.load); }); p.tload.forEach(function (l) { loads.push(l); }); });
    loads = nums(loads);
    if (loads.length) { var lt = loads.length === 1 ? loads[0] + 'kg' : (loads.length > 5 ? 'between ' + loads[0] + 'kg and ' + loads[loads.length - 1] + 'kg' : loads.slice(0, -1).join('kg, ') + 'kg or ' + loads[loads.length - 1] + 'kg'); qs.push(SHELF ? ['How much weight does each shelf take?', 'The rated load on these listings is ' + lt + ' per shelf, depending on the product and the option you pick. Ratings assume the weight is spread evenly across the shelf; a heavy load in the middle of a shelf counts for more.'] : ['How much weight will it take?', 'The rated load on these listings is ' + lt + ', depending on the product and the option you pick. Each listing states its own rating.']); }
    if (!qs.length) { if (!$('[data-src-rte]')) $('.src-about').hidden = true; return; }
    var list = $('[data-src-faqlist]');
    list.innerHTML = qs.slice(0, 4).map(function (q, i) {
      return '<details class="src-q"' + (i === 0 ? ' open' : '') + '><summary>' + esc(q[0]) + '<i aria-hidden="true"></i></summary><div>' + (q[2] ? q[1] : esc(q[1])) + '</div></details>';
    }).join('');
    $('[data-src-faq]').hidden = false;
    if (!$('[data-src-rte]')) $('[data-src-aboutg]').classList.add('src-about__g--one');
  })();
})();
